export const RideProductionFields = {
  id: "id",
  logs: "logs",
  logsData: "logData",
  logsCount: "logsCount",
};
